import { createFileRoute } from '@tanstack/react-router';

import { ShortlistPage } from '@/features/profiles/company-pages';

export const Route = createFileRoute('/_app/org/$orgId/shortlist')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <ShortlistPage orgId={orgId} />;
}
